const BANNED_WORDS = [
  'guest', 'admin', 'moderator', 'support', 'system',
  'fuck', 'shit', 'piss', 'cunt', 'dick', 'asshole', 'bitch',
  'nigger', 'faggot', 'retard'
];

export function validateNickname(nickname: string): { isValid: boolean; error?: string } {
  const trimmed = nickname.trim().toLowerCase();
  
  if (trimmed.length < 3) {
    return { isValid: false, error: 'Name must be at least 3 characters' };
  }
  
  if (trimmed.length > 12) {
    return { isValid: false, error: 'Name must be under 12 characters' };
  }

  // Check for allowed characters (alphanumeric and underscores)
  if (!/^[a-zA-Z0-9_]+$/.test(trimmed)) {
    return { isValid: false, error: 'Only letters, numbers, and _ allowed' };
  }

  // Profanity and Guest check
  const containsBanned = BANNED_WORDS.some(word => trimmed.includes(word));
  if (containsBanned) {
    return { isValid: false, error: 'Name contains invalid or restricted words' };
  }

  return { isValid: true };
}
